import { useLocation, useNavigate } from "react-router-dom";
import React, { useRef } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import org from "./../data/orgDetails.json";
import "./styling/CertificateView.css";
import Header from "./Header";
import Footer from "./Footer.jsx";
import inchargeSign from "../assets/asetc/incharge_sign.png";
import directorSign from "../assets/asetc/dir_sign.png";

const CertificateView = () => {
  const certRef = useRef();
  const OrgDetails = org[0];
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user;

  if (!user) {
    // Optionally redirect to home if no user data
    setTimeout(() => navigate("/", { replace: true }), 2000);
    return (
      <div className="certificate-wrapper">
        <div className="certificate-error">No user data found. Redirecting to home...</div>
      </div>
    );
  }

  const handleDownload = async () => {
    const element = certRef.current;
    // Get the exact size of the element
    const rect = element.getBoundingClientRect();
    const canvas = await html2canvas(element, {
      scale: 4, // high resolution
      useCORS: true,
      width: rect.width,
      height: rect.height,
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: rect.width,
      windowHeight: rect.height,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("landscape", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;
    const ratio = Math.min(pageWidth / imgWidth, pageHeight / imgHeight);
    const finalWidth = imgWidth * ratio;
    const finalHeight = imgHeight * ratio;
    const x = (pageWidth - finalWidth) / 2;
    const y = (pageHeight - finalHeight) / 2;
    pdf.addImage(imgData, "PNG", x, y, finalWidth, finalHeight);
    pdf.save(`certificate-${user.registrationNumber}.pdf`);
  };

  // Download as JPG
  const handleDownloadJPG = async () => {
    const element = certRef.current;
    const rect = element.getBoundingClientRect();
    const canvas = await html2canvas(element, {
      scale: 4,
      useCORS: true,
      width: rect.width,
      height: rect.height,
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: rect.width,
      windowHeight: rect.height,
    });
    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const link = document.createElement("a");
    link.href = imgData;
    link.download = `certificate-${user.registrationNumber}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Header />
      <div className="certificate-wrapper">
        <div className="certificate" ref={certRef}>
          <h1 className="org-name">{OrgDetails.name}</h1>
          <h3 className="org-subheading">{OrgDetails.desc}</h3>

          {/* Serial No & Date of Issue */}
          <div className="cert-top-details">
            <div>Sl. No: {user.serialNumber && user.serialNumber.trim() !== "" ? user.serialNumber : "__________"}</div>
            <div>Date of Issue: {user.issueDate && user.issueDate.trim() !== ""? user.issueDate : "__________"}</div>
          </div>

          <h2 className="cert-title">Certificate of Appreciation</h2>

          <p className="cert-body">
            This is to certify that Mr./Mrs/Miss <br />
            <span className="highlight">{user.name && user.name.trim() !== "" ? user.name : "__________" }</span>,<br />
            son/daughter/wife/care of <br />
            <span className="highlight">{user.fathersName && user.fathersName.trim() !== "" ? user.fathersName : "__________"}</span>, <br />
            has successfully completed the <br />
            <span className="highlight">{user.course && user.course.trim() !== ""? user.course : "__________"}</span> <br /> course conducted
            from <span className="highlight">{user.startMonth && user.startMonth.trim() !== ""? user.startMonth : "__________"}</span> to{" "}
            <span className="highlight">{user.endMonth && user.endMonth.trim() !== "" ? user.endMonth : "__________"}</span> is placed in the{" "}
            <br />
            <span className="highlight">{user.grade && user.grade.trim() !== "" ? user.grade : "__________"}</span> Grade in the final
            examination.
          </p>

          <div className="cert-details">
            <p>Registration No: {user.registrationNumber && user.registrationNumber.trim() !== ""? user.registrationNumber : "__________"}</p>
            <p>Date of Birth: {user.dob? user.dob : "__________"}</p>
          </div>

          <div className="signatures">
            <div className="signature-block">
              <img src={inchargeSign} alt="Center Incharge Signature" className="signature-img" />
              <span>___________________</span>
              <span>Center Incharge</span>
            </div>
            <div className="signature-block">
              <img src={directorSign} alt="Director Signature" className="signature-img" />
              <span>___________________</span>
              <span>Director</span>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", gap: "1rem", justifyContent: "center", marginTop: "1.5rem" }}>
          <button className="download-btn" onClick={handleDownload}>
            Download as PDF
          </button>
          <button className="download-btn" onClick={handleDownloadJPG}>
            Download as JPG
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CertificateView;
